import { schCompType, schFilledAddress } from '@aloft/toolkit-shared';

import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { schMlsListingInfo } from '../../../../components/MLSInput/types.ts';

export type CompEntryType = 'mls' | 'address';

export const schCompEntry = z.discriminatedUnion('method', [
  z.strictObject({
    method: z.literal('mls'),
    mls: schMlsListingInfo.shape.mls,
    mlsListingID: schMlsListingInfo.shape.mlsListingID,
  }),
  z.strictObject({
    method: z.literal('address'),
    AddressLineText: schFilledAddress.shape.AddressLineText,
    unitNumber: schFilledAddress.shape.unitNumber,
    CityName: schFilledAddress.shape.CityName,
    StateCode: schFilledAddress.shape.StateCode,
    PostalCode: schFilledAddress.shape.PostalCode,
  }),
]);

export type CompEntry = z.infer<typeof schCompEntry>;

export const schAddComparablesForm = z.strictObject({
  entries: z.array(schCompEntry),
  compType: schCompType.optional(),
});

export type AddComparablesForm = z.infer<typeof schAddComparablesForm>;

export type AddCompsFormProps = {
  form: UseFormReturn<
    z.input<typeof schAddComparablesForm>,
    unknown,
    z.infer<typeof schAddComparablesForm>
  >;
};
